export const Roles = {
  // Customer
  CUSTOMER_WHOLESALER: 'CustomerPR',
  CUSTOMER_RETAIL: 'Customer',

  // Commercial / Hierarchy
  SELLER: 'Seller',
  SUB_MANAGER: 'Submanager',
  MANAGER: 'Manager',
  REGIONAL_MANAGER: 'RegionalManager',
  SUB_DIRECTOR_NON_COMMERCIAL_WHOLESALER: 'SubDirectorPRNoCommercial',
  SUB_DIRECTOR_NON_COMMERCIAL_RETAIL: 'SubDirectorDTNoCommercial',
  SUB_DIRECTOR: 'Subdirector',
  DIRECTOR_NON_COMMERCIAL: 'DirectorNoCommercial',
  DIRECTOR: 'Director',

  // Department / Area Roles
  LOGISTICS: 'Logistics',
  EXPRESS_SALES: 'IELExpressSales',
  CREDIT_ASSISTANT: 'CreditAssistant',
  CREDIT_COLLECTIONS: 'Credit',
  BRIEFCASE: 'IELBriefcase',
  MARKETING: 'IELMarketing',
  POST_SALE: 'PostSale',
  PRESIDENCY: 'Presidency',

  // System / Admin
  ADMIN: 'Administrator',
  ADMIN_NOTIFICATION: 'NotificationAdmin',
  ADMIN_PROMOTION: 'AdminPromotion',
  SUPER_USER: 'Superuser',
};

// Meta role names used in route metadata

export const MetaRoles = {
  [Roles.REGIONAL_MANAGER]: 'Regional',
  [Roles.MANAGER]: 'Manager',
  [Roles.SELLER]: 'Seller',
  [Roles.DIRECTOR]: 'Director',
  [Roles.SUB_DIRECTOR]: 'Subdirector',
};
